// extracted by mini-css-extract-plugin
export var buttonWrap = "external_link_modal-module--button-wrap--35a79";
export var modal = "external_link_modal-module--modal--0eebd";
export var modalContent = "external_link_modal-module--modal-content--702e6";